/**
 * Shared Root Cause Analysis constants.
 */

/**
 * Max rows requested from shutdown / alarm history APIs for RCA panels.
 * Used for request `resultsLimit` / `ResultLimit` and the truncated-results disclaimer.
 */
export const RCA_LIST_RESULTS_LIMIT = 100;
